module.exports = __webpack_public_path__ + "img/logo.7f7bbfc0.png";